import React, { useCallback } from 'react';
import { Button, Icon } from '@servicetitan/anvil2';
import MicIcon from '@servicetitan/anvil2/assets/icons/material/round/mic.svg';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import { audioDeviceStrings } from '../audioDeviceStrings';
import styles from './AudioDevicePanel.module.css';
import { MicrophoneLevelMeter } from './MicrophoneLevelMeter';

export interface MicrophoneTestButtonProps {
  isTestingMicrophone: boolean;
  microphoneAnalyser: AnalyserNode | null;
  disabled: boolean;
}

export const MicrophoneTestButton: React.FC<MicrophoneTestButtonProps> = ({
  isTestingMicrophone,
  microphoneAnalyser,
  disabled,
}) => {
  const handleClick = useCallback(() => {
    if (isTestingMicrophone) {
      SoftPhoneModule.stopMicMonitor();
    } else {
      SoftPhoneModule.startMicMonitor();
    }
  }, [isTestingMicrophone]);

  return (
    <Button
      appearance='secondary'
      disabled={disabled}
      onClick={handleClick}
      data-testid='audio-device-panel-test-microphone'
      className={styles.testButton}
    >
      {isTestingMicrophone && microphoneAnalyser ? (
        <MicrophoneLevelMeter analyserNode={microphoneAnalyser} />
      ) : (
        <Icon svg={MicIcon} size='medium' />
      )}
      {isTestingMicrophone
        ? audioDeviceStrings.testButtons.listeningMicrophone
        : audioDeviceStrings.testButtons.testMicrophone}
    </Button>
  );
};
